import {
  BlockCategory,
  BlockCustomIconVariant,
  BlockLifeCycle,
  BlockSafetyLevel,
} from 'flow-schema';
import { z } from 'zod';

import { AnyBlockTypeSchema, UnknownBlockType } from './flowDefinition.js';
import { BaseItemSchema } from '../common.js';

export const BaseBlockTypeMetadataSchema = z.object({
  blockType: AnyBlockTypeSchema,
  name: z.string(),
  description: z.string(),
  blockCategory: z.enum(BlockCategory),
  blockSafetyLevel: z.enum(BlockSafetyLevel),
  blockLifeCycle: z.enum(BlockLifeCycle),
  blockLifeCyclePriority: z.number().int(),
  customIconVariant: z.enum(BlockCustomIconVariant).nullish(),
  searchKeywords: z.array(z.string()).nullish(),
});
export type BaseBlockTypeMetadata = z.infer<typeof BaseBlockTypeMetadataSchema>;

export const BlockTypeMetadataSchema = BaseItemSchema.merge(BaseBlockTypeMetadataSchema);
export type BlockTypeMetadataSchema = z.infer<typeof BlockTypeMetadataSchema>;

export const UnknownBlockTypeMetadata: BaseBlockTypeMetadata = {
  blockType: UnknownBlockType.Unknown,
  name: 'Unknown',
  description: `Unknown block type.
This may be a new block type that is not synchronized yet.
`,
  blockCategory: BlockCategory.Obsolete,
  blockSafetyLevel: BlockSafetyLevel.Unsafe,
  blockLifeCycle: BlockLifeCycle.Retired,
  // Matches what the generated blockLifeCyclePriority column stores for Retired.
  blockLifeCyclePriority: 4,
};
